import React, { useRef, useEffect, useState, Fragment } from "react";
import { connect } from "react-redux";
import Table from "../Table";
import Card from "../Card";
import { getFavorites } from "../../../redux/actions/Projects";

const Favorites: React.FC<{
  favorites: any;
  getFavorites: () => void;
  highlightProject: any;
  setHighlightProject: any;
  setEllipsisClick: any;
}> = ({
  favorites,
  getFavorites,
  highlightProject,
  setHighlightProject,
  setEllipsisClick,
}) => {
  const [viewState, setViewState] = useState("box") as any;
  const handleBoxClick = () => {
    setViewState("box");
  };

  const handleListClick = () => {
    setViewState("list");
  };

  useEffect(() => {
    getFavorites();
  }, []);

  return (
    <>
      <div
        className="subTitle"
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <p
          style={{ paddingLeft: "25px", fontWeight: "bold", fontSize: "16px" }}
        >
          Favorites
        </p>
        <div className="push">
          <i
            onClick={handleBoxClick}
            className="fa fa-th"
            style={{
              marginRight: "30px",
              color: viewState === "box" ? "black" : "lightgrey",
            }}
          ></i>
          <i
            onClick={handleListClick}
            style={{ color: viewState === "list" ? "black" : "lightgrey" }}
            className="fa fa-list-ul"
          ></i>
        </div>
      </div>
      <div
        className="header2"
        style={
          viewState === "box"
            ? {
                maxHeight: "100vh",
                overflowY: "auto",
              }
            : { marginTop: 0 }
        }
      >
        {/* all your projects here  */}
        {viewState === "box" ? (
          favorites?.map((item: any, index: number) => (
            <Card
              key={index}
              item={item}
              index={index}
              bottom={index === favorites.length - 1}
              highlightProject={highlightProject}
              setHighlightProject={setHighlightProject}
              setEllipsisClick={setEllipsisClick}
              // allItems={favorites}
            />
          ))
        ) : (
          <Table
            projectList={favorites}
            // handleClick={() => console.log("CLicked")}
            // setProjectClicked={() => console.log("CLicked")}
            // openDeleteM={() => console.log("CLicked")}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  favorites: state.projects.favorites,
});

export default connect(mapStateToProps, { getFavorites })(Favorites) as any;
